import { useEasyModeContext } from '../contexts/EasyModeContext';
import {
  EASY_MODE_FOOTER_LABELS,
  EASY_MODE_TOTAL_STEPS,
  isFirstEasyModeStep,
  isLastEasyModeStep
} from '../constants/easyModeSteps';

const getFirstMessage = ({ validation }) =>
  validation.errors ? Object.values(validation.errors)[0] : validation.error;

const useEasyModeFooterProps = () => {
  const { step, stepValidation, goNext, goBack, intake, submission } = useEasyModeContext();
  const validation = stepValidation[step];

  const sharedProps = {
    step,
    totalSteps: EASY_MODE_TOTAL_STEPS,
    label: EASY_MODE_FOOTER_LABELS[step]
  };

  if (isLastEasyModeStep(step)) {
    return {
      ...sharedProps,
      isBackVisible: true,
      onBack: goBack,
      // an existing run relabels the button, since a second click restarts the assistant with the edited details
      primaryLabel: submission.hasExistingRun ? 'Regenerate Demand' : 'Generate Demand',
      isPrimaryIconVisible: true,
      isPrimaryDisabled: submission.isSubmitDisabled,
      isPrimaryLoading: submission.isSubmitting,
      primaryTooltip: submission.submitTooltip,
      onPrimary: submission.submit
    };
  }

  return {
    ...sharedProps,
    // every step past the first carries a Back button; only step 1 has nowhere to go back to
    isBackVisible: !isFirstEasyModeStep(step),
    onBack: goBack,
    primaryLabel: 'Next',
    isPrimaryIconVisible: false,
    isPrimaryLoading: intake.isSaving,
    isPrimaryDisabled: !validation.isValid,
    primaryTooltip: validation.isValid ? '' : getFirstMessage({ validation }),
    onPrimary: goNext
  };
};

export default useEasyModeFooterProps;
